import Sun from '../../src/legacy/Sun';
export default Sun;
